
import CardBody from '@/components/card-body/index.vue'
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import DashboardBlock from '@/components/dashboard-block/index.vue'
import CommonTable from '@/components/common-table/index.vue'
import { ElTable } from 'element-ui/types/table'
import PageRequest from '@/entities/page-request'
import workzone from '@/mixins/workzone'
import Dashboard from '@/entities/dashboard'
import dayjs from 'dayjs'
import config from '@/config'

class PageListRequest extends PageRequest {
  dateFrom: string
  dateTo: string
  workZoneCode: string
}
const defaultDateFrom = dayjs()
  .date(1)
  .format('YYYY-MM-DD 00:00:00')
const defaultDateTo = dayjs().format('YYYY-MM-DD 23:59:59')

@Component({
  components: {
    CardBody,
    DashboardBlock,
    CommonTable
  },
  mixins: [workzone]
})
export default class DashboardPage extends AbpBase {
  [x: string]: any
  name: 'Dashboard'

  pagerequest = new PageListRequest()

  getTableRef(): ElTable {
    return this.$refs.commonTable as ElTable
  }

  loading = false

  tableDataList = []

  async doTableSearch() {
    this.pagerequest.workZoneCode =
      this.workZone === 'ALL' ? this.table.query.workZoneCode : this.workZone
    this.pagerequest.dateFrom = this.table.query.dateFrom
    this.pagerequest.dateTo = this.table.query.dateTo
    await this.requestPageData()
  }

  defaultDateFrom = dayjs()
    .date(1)
    .format('YYYY-MM-DD 00:00:00')
  defaultDateTo = dayjs().format('YYYY-MM-DD 23:59:59')

  table = this.$standardTableData({
    showPagination: false,
    height: `calc(${config.commonTableHeight} - 170px)`,
    query: {
      dateFrom: defaultDateFrom,
      dateTo: defaultDateTo,
      workZoneCode: null
    },
    searchData: [
      {
        type: 'dateRange',
        title: 'Date Range',
        clearable: true,
        modelName: ['dateFrom', 'dateTo'],
        dateFrom: defaultDateFrom,
        dateTo: defaultDateTo
      },
      {
        type: 'select',
        model: 'workZoneCode',
        title: 'Store',
        key: 'WorkZone',
        clearable: true,
        filterable: true,
        option: [],
        hide: false
      }
    ],
    columns: [
      {
        title: this.L('Date'),
        key: 'creationTime',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.date(ctx.row))
        }
      },
      {
        title: this.L('TRANSACTION'),
        key: 'description'
      },
      {
        title: this.L('Reference No.'),
        key: 'controlNo'
      },
      {
        title: this.L('Location'),
        key: 'locationId'
      },
      {
        title: this.L('Trace Id/Vehicle No.'),
        key: 'traceId'
      },
      {
        title: this.L('Action By'),
        key: 'creatorUserName'
      }
    ]
  })

  info: Dashboard = new Dashboard()

  async requestPageData() {
    try {
      this.loading = true
      let res = await this.$store.dispatch({
        type: 'dashboard/getDashboard',
        data: this.pagerequest
      })
      this.info = res || {}
      this.tableDataList = res.latestActivities || []
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  async created() {
    await this.handleWorkZoneSearchData(this.table)
    await this.doTableSearch()
  }
}
